import React from "react"
import { Store } from "./src/state"

export const wrapRootElement = ({ element }) => <Store>{element}</Store>
